import { useEffect, useState } from "react";
import { FlowService } from "../../../service/FlowService";

interface UseEntityExistsResult {
    isDeleted: boolean;
    isChecking: boolean;
}

export function useEntityExists(
    entityId: string | undefined,
    entityType: "chatbot" | "flow" | "form",
): UseEntityExistsResult {
    const [isDeleted, setIsDeleted] = useState(false);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        if (!entityId) {
            setIsChecking(false);
            return;
        }

        const controller = new AbortController();

        const checkEntity = async () => {
            setIsChecking(true);
            try {
                await FlowService.getFlow(entityId, controller.signal);
                setIsDeleted(false);
            } catch {
                if (!controller.signal.aborted) {
                    setIsDeleted(true);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setIsChecking(false);
                }
            }
        };

        checkEntity();

        return () => {
            controller.abort();
        };
    }, [entityId, entityType]);

    return { isDeleted, isChecking };
}
